import { es, en, ptBr } from './locale';
import routes from './routes';

const DenunciaModule = {
    init: ({ i18n, router }) => {
        i18n.mergeLocaleMessage('pt-BR', {
            denuncia: {
                ...ptBr
            }
        });
        i18n.mergeLocaleMessage('en', {
            denuncia: {
                ...en
            }
        });
        i18n.mergeLocaleMessage('es', {
            denuncia: {
                ...es
            }
        });

        router.addRoutes(routes);
    }
};

export default DenunciaModule;
